module.exports = __webpack_public_path__ + "img/logo-sign-up.7755efe.png";